import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog } from '@mui/material';
import { CURRENCY_FORMATTER } from 'common/constants';
import { useForm } from 'react-hook-form';
import { getStorePermissions } from 'v3/data/store/stores/actions';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { NumberFormatInput } from 'v3/shared/components/Inputs/NumberFormatInput';
import { priceSchema } from 'v3/shared/schemas/chancePrice';
import { HeadlineLarge } from 'v3/shared/typography/HeadlineLarge';
import { AlignButtons, AlignLeft, changeValuePaperPropsStyle, Container, StyledCloseIcon } from './styles';
import { IChangeValueModalProps } from './types';

export const ChangeValueModal: React.FC<IChangeValueModalProps> = ({ modal, onClose, onConfirm }) => {
  const { isMobile } = useBreakpoints();
  const { allowZeroLMI } = getStorePermissions();

  const { control, getValues, formState } = useForm<{ price: number }>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(priceSchema(allowZeroLMI, modal.maxPrice)),
    values: { price: modal.initialPrice },
  });

  const handleOnNextClick = () => {
    const { price } = getValues();
    onConfirm(Number(price * CURRENCY_FORMATTER));
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={modal.active}
      aria-labelledby="customized-dialog-title"
      PaperProps={changeValuePaperPropsStyle}
    >
      <Container>
        <StyledCloseIcon onClick={onClose} />
        <AlignLeft>
          <HeadlineLarge>{modal.title}</HeadlineLarge>
          <InputFormController
            data-testid="input-price"
            inputType="tel"
            formControl={control}
            formControlName="price"
            label="Preço"
            mask="R$ 0.000,00"
            placeholder="R$ 0.000,00"
            fullWidth={false}
            customMask={NumberFormatInput}
          />
        </AlignLeft>
        <AlignButtons>
          {modal.activeButton && (
            <TextButton
              data-testid="text-button-cancel"
              size="small"
              $outline
              text={modal.cancelButton}
              handleClick={onClose}
              fullWidth={isMobile}
            />
          )}
          {modal.activeButton && (
            <FlexButton
              data-testid="flex-button-save-button"
              size="small"
              text={modal.saveButton}
              handleClick={handleOnNextClick}
              fullWidth={isMobile}
              disabled={!formState.isValid}
            />
          )}
        </AlignButtons>
      </Container>
    </Dialog>
  );
};
